import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Popover,
  Autocomplete,
  Collapse,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SortIcon from "@mui/icons-material/Sort";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getCategories,
  getsubCategories,
  createsubCategory,
  updatesubCategory,
  deletesubCategory,
} from "../../../Services/Services";
// Line 1-20 ke beech add karo
import { useMediaQuery, useTheme } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "lodash.debounce";

const DivisionManagementTable = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [categoryToDelete, setcategoryToDelete] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategoryFilter, setSubCategoryFilter] = useState("");
  const [errors, setErrors] = useState([{ name: "", category_id: "" }]); // ✅ ADD THIS LINE
  const [categoryFilter, setCategoryFilter] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [formData, setFormData] = useState({ category_id: "" });
  const [selectedFilterCategory, setSelectedFilterCategory] = useState(null);
  const [filterCategoryOptions, setFilterCategoryOptions] = useState([]);
  const [filterCategoryLoading, setFilterCategoryLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [categoryForms, setCategoryForms] = useState([
    { name: "", category_id: "" },
  ]);

  const [categoryForm, setCategoryForm] = useState({
    name: "",
    category_id: "", // used for UI
    created_by: localStorage.getItem("user_id"),
  });
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryPage, setCategoryPage] = useState(1);
  const [categoryHasMore, setCategoryHasMore] = useState(true);
  const [categorySearch, setCategorySearch] = useState("");
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  const handleAddRow = () => {
    if (categoryForms.length >= 5) {
      toast.error("You can add maximum 5 units");
      return;
    }
    setCategoryForms([...categoryForms, { name: "", category_id: "" }]);
    setErrors([...errors, { name: "", category_id: "" }]);
    // setTouched([...touched, { name: false, symbol: false }]);
  };
  // ✅ YE ADD KARO
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedCategory, setExpandedCategory] = useState(null); // ← ADD THIS LINE

  const handleRemoveField = (index) => {
    const updatedForms = categoryForms.filter((_, i) => i !== index);
    setCategoryForms(updatedForms);
  };

  const fetchSubCategories = async (
    reset = false,
    subcategory = "",
    categoryId = "",
  ) => {
    setLoading(true);
    const currentPage = reset ? 1 : page;

    const data = await getsubCategories(currentPage, subcategory, categoryId);

    if (data) {
      if (reset) {
        setCategories(data.results);
        setPage(2);
      } else {
        setCategories((prev) => [...prev, ...data.results]);
        if (data.next) setPage((prev) => prev + 1);
      }
      setHasMore(!!data.next);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchFilterCategories();
  }, []);

  // ✅ NEW: Fetch categories for filter dropdown
  const fetchFilterCategories = async () => {
    setFilterCategoryLoading(true);
    try {
      const data = await getCategories();
      const results = Array.isArray(data) ? data : data.results || [];
      setFilterCategoryOptions(results);
    } finally {
      setFilterCategoryLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      const categoryId = selectedFilterCategory?.id || "";

      // ✅ Only fetch if category is selected OR subcategory search has text
      if (categoryId || subCategoryFilter.trim()) {
        fetchSubCategories(true, subCategoryFilter, categoryId);
      } else {
        // ✅ Clear table when no filter
        setCategories([]);
        setHasMore(false);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [subCategoryFilter, selectedFilterCategory]);

  const fetchCategories = async (page = 1, search = "") => {
    setCategoryLoading(true);
    try {
      const data = await getCategories(page, search);
      const results = Array.isArray(data) ? data : data.results || [];

      if (page === 1) {
        setCategoryOptions(results); // fresh search
      } else {
        setCategoryOptions((prev) => [...prev, ...results]); // pagination append
      }

      setCategoryHasMore(!!data.next); // agar next page hai
      setCategoryPage(page + 1);
    } finally {
      setCategoryLoading(false);
    }
  };

  // jab user type kare
  const handleCategorySearch = debounce((value) => {
    setCategorySearch(value);
    setCategoryPage(1);
    fetchCategories(1, value);
  }, 500);

  const setHandleOpen = () => {
    fetchAllCategories();
    setCategorySearch(""); // ✅ Reset search
    setCategoryPage(1); // ✅ Reset page
    fetchCategories(1, ""); // ✅ Load fresh categories
    setOpen(true);
  };

  const fetchAllCategories = async () => {
    const data = await getCategories(); // not subcategories!
    setCategoriesList(Array.isArray(data) ? data : data?.results || []);
  };
  const handleSave = async () => {
    const createdBy = localStorage.getItem("user_id");
    let hasError = false;
    const newErrors = [];

    // validate each row
    categoryForms.forEach((row, index) => {
      newErrors[index] = { name: "", category_id: "" };
      if (!row.name.trim()) {
        newErrors[index].name = "Sub Category Name is required";
        hasError = true;
      }
      if (!row.category_id) {
        newErrors[index].category_id = "Category is required";
        hasError = true;
      }
    });

    setErrors(newErrors);
    if (hasError) return;

    try {
      if (editId) {
        const payload = {
          name: categoryForms[0].name,
          category: categoryForms[0].category_id,
          created_by: createdBy,
        };

        const update_response = await updatesubCategory(editId, payload);

        setCategories((prev) =>
          prev.map((cat) => (cat.subcat_id === editId ? update_response : cat)),
        );
        toast.success("Updated successfully");

        // reset modal
        setEditId(null);
        setCategoryForm({ name: "", category_id: "", created_by: createdBy });
      } else {
        // Multi-row create functionality
        const createdResponses = [];
        for (const row of categoryForms) {
          const payload = {
            name: row.name,
            category: row.category_id,
            created_by: createdBy,
          };
          const res = await createsubCategory(payload);
          createdResponses.push(res);
        }
        setCategories([...createdResponses, ...categories]); // update table
        toast.success("All subcategories created successfully");
      }

      // reset modal for both cases
      setCategoryForms([{ name: "", category_id: "" }]);
      setEditId(null); // reset edit mode
      setOpen(false);
      setErrors([]);
      setOpen(false);
    } catch (err) {
      console.error(err);
      toast.error("Operation failed");
    }
  };

  const handleDelete = async (id) => {
    if (!id) return;
    try {
      await deletesubCategory(id); // API call

      // ✅ remove from state
      setCategories((prev) => prev.filter((cat) => cat.subcat_id !== id));

      toast.success("Deleted successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete");
    } finally {
      setAnchorEl(null);
      setcategoryToDelete(null);
    }
  };

  // ✅ Fix Edit
  const handleEdit = (cat) => {
    fetchAllCategories();
    setCategoryForms([
      {
        name: cat.name,
        category_id: cat.category_id || cat.category || "",
      },
    ]);

    setEditId(cat.subcat_id);
    setOpen(true);
  };

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }
  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  return (
    <Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          gap: { xs: 1, sm: 2 },
          position: "sticky", // sticky header
          top: 0,
          zIndex: 1100, // table ke rows ke upar
          backgroundColor: "#fff", // ya table header color
          // padding: "8px 16px", // thoda padding
          // borderBottom: "1px solid #ccc", // optional underline
        }}
      >
        {/* Left side inputs */}
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          gap={2}
          flex={1}
          width="100%"
        >
          {/* Search by Category */}
          {/* Search by Category */}
          <Autocomplete
            options={filterCategoryOptions} // ✅ FIX: Use categories, not subcategories
            getOptionLabel={(option) => option.name || ""}
            value={selectedFilterCategory} // ✅ Use proper state
            onChange={(e, value) => {
              setSelectedFilterCategory(value); // ✅ Set selected category object
            }}
            loading={filterCategoryLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search by Category"
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                    fontSize: "0.7rem",
                    borderRadius: 0,
                    padding: "0 8px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.7rem",
                  },
                }}
              />
            )}
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "auto" },
            }}
          />
          {/* Search by Sub Category */}
          <TextField
            label="Search by Sub Category"
            variant="outlined"
            size="small"
            value={subCategoryFilter}
            onChange={(e) => setSubCategoryFilter(e.target.value)}
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                fontSize: "0.7rem",
                borderRadius: 0,
                padding: "0 8px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />
        </Box>

        {/* Right side button */}
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          onClick={() => setHandleOpen()}
          sx={{
            ml: { xs: 0, sm: 2 },
            mt: { xs: 1, sm: 0 },
            height: "30px", // button chhota
            fontSize: "0.7rem",
            padding: "4px 10px",
            borderRadius: "0px",
            width: { xs: "100%", sm: "auto" }, // mobile me full width
          }}
        >
          Sub Category
        </Button>
      </Box>
      <InfiniteScroll
        dataLength={categories.length}
        next={() => fetchSubCategories()}
        hasMore={hasMore}
        // height={isMobile ? "75vh" : "80vh"}
        loader={<h4>Loading...</h4>}
      >
        <div id="project-table-print">
          {isMobile ? (
            /* 📱 MOBILE VIEW */
            <Box sx={{ bgcolor: "background.paper" }}>
              {/* Case 1: No filter applied - Show instruction message */}
              {categories.length === 0 &&
              !selectedFilterCategory &&
              !subCategoryFilter ? (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    Please select a category to view subcategories
                  </Typography>
                </Box>
              ) : /* Case 2: Filter applied but no results found */
              categories.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    No subcategories found
                  </Typography>
                </Box>
              ) : (
                /* Case 3: Display actual data */
                categories.map((cat, index) => (
                  <Box key={cat.subcat_id || index}>
                    {/* Main Row - Always Visible */}
                    <Box
                      onClick={() =>
                        setExpandedCategory(
                          expandedCategory === cat.subcat_id
                            ? null
                            : cat.subcat_id,
                        )
                      }
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1.5,
                        cursor: "pointer",
                        bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:active": {
                          bgcolor: "#e3f2fd",
                        },
                        borderLeft: "4px solid #1976d2",
                      }}
                    >
                      {/* Left Side - Main Info */}
                      <Box sx={{ flex: 1 }}>
                        {/* S.No + Category Name */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#666",
                              minWidth: 25,
                            }}
                          >
                            {index + 1}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.85rem",
                              flex: 1,
                            }}
                          >
                            {cat.category_name}
                          </Typography>
                        </Box>

                        {/* Sub Category */}
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <span style={{ fontWeight: 500, marginLeft: 35 }}>
                            {cat.name?.substring(0, 25) || "N/A"}
                          </span>
                        </Typography>
                      </Box>

                      {/* Expand Icon */}
                      <IconButton size="small" sx={{ ml: 1 }}>
                        {expandedCategory === cat.subcat_id ? (
                          <ExpandLess fontSize="small" />
                        ) : (
                          <ExpandMore fontSize="small" />
                        )}
                      </IconButton>
                    </Box>

                    {/* Expanded Details */}
                    <Collapse
                      in={expandedCategory === cat.subcat_id}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box
                        sx={{
                          px: 1.5,
                          py: 1,
                          bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                          borderLeft: "4px solid #1976d2",
                        }}
                      >
                        {/* Detailed Info - 2 Column Grid */}
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 0.8,
                            mb: 1,
                          }}
                        >
                          {/* S.NO */}
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              S.NO
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.72rem",
                                fontWeight: 500,
                                color: "#555",
                              }}
                            >
                              #{index + 1}
                            </Typography>
                          </Box>

                          {/* DATE */}
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              DATE
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.72rem",
                                fontWeight: 500,
                                color: "#555",
                              }}
                            >
                              {formatOnlyDate(cat.created_at)}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Category - Full Width */}
                        <Box sx={{ mb: 0.8 }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                              mb: 0.3,
                            }}
                          >
                            CATEGORY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#555",
                              lineHeight: 1.3,
                              fontWeight: 500,
                            }}
                          >
                            {cat.category_name}
                          </Typography>
                        </Box>

                        {/* Sub Category - Full Width */}
                        <Box sx={{ mb: 0.8 }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                              mb: 0.3,
                            }}
                          >
                            SUB CATEGORY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#555",
                              lineHeight: 1.3,
                              fontWeight: 500,
                            }}
                          >
                            {cat.name}
                          </Typography>
                        </Box>

                        <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                        {/* Action Buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              fontWeight: 600,
                              letterSpacing: "0.5px",
                            }}
                          >
                            ACTIONS
                          </Typography>

                          {/* Edit & Delete Buttons */}
                          <Box sx={{ display: "flex", gap: 0.6 }}>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(cat);
                              }}
                              sx={{
                                bgcolor: "#e3f2fd",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#bbdefb",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <EditIcon
                                sx={{ fontSize: "1rem", color: "#1976d2" }}
                              />
                            </IconButton>

                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setAnchorEl(e.currentTarget);
                                setcategoryToDelete(cat.subcat_id);
                              }}
                              sx={{
                                bgcolor: "#ffebee",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#ffcdd2",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <DeleteIcon
                                sx={{ fontSize: "1rem", color: "#d32f2f" }}
                              />
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    </Collapse>

                    {/* Divider between items */}
                    <Divider />
                  </Box>
                ))
              )}
            </Box>
          ) : (
            /* 💻 DESKTOP VIEW - Same Table */
            <TableContainer
              component={Paper}
              id="i"
              sx={{
                maxHeight: "88vh",
                overflow: "auto",
                width: "100%",
              }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  minWidth: 1000,
                  "& td, & th": {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    borderBottom: "1px solid #ccc",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& th": {
                        fontWeight: "bold",
                        color: "#333",
                        borderBottom: "1px solid #999",
                        backgroundColor: "#f5f5f5",
                        fontsize: "0.7rem",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                      }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#f5f5f5" }}>
                      Category
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#f5f5f5" }}>
                      Sub Category
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#f5f5f5" }}>
                      Date
                    </TableCell>
                    <TableCell
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        maxWidth: 30,
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {categories.length === 0 &&
                  !selectedFilterCategory &&
                  !subCategoryFilter ? (
                    // ✅ Show message when nothing selected
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Typography variant="body2" color="text.secondary">
                          Please select a category to view subcategories
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : categories.length === 0 ? (
                    // ✅ Show when search returns no results
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Typography variant="body2" color="text.secondary">
                          No subcategories found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    categories.map((cat, index) => (
                      <TableRow
                        hover
                        key={cat.subcat_id || index}
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "#fafafa" : "#ffffff",
                          "& td": {
                            paddingRight: "13px !important",
                            paddingLeft: "13px !important",
                            padding: "0px",
                            fontSize: { xs: "0.65rem", sm: "0.75rem" },
                            whiteSpace: "nowrap",
                          },
                          "&:hover": {
                            backgroundColor: "#e3f2fd !important",
                            "& td": { backgroundColor: "#e3f2fd !important" },
                          },
                        }}
                      >
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "inherit",
                            zIndex: 1,
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell>{cat.category_name}</TableCell>
                        <TableCell>{cat.name}</TableCell>
                        <TableCell>{formatOnlyDate(cat.created_at)}</TableCell>
                        <TableCell
                          className="no-print"
                          sx={{
                            position: "sticky",
                            right: 0,
                            backgroundColor: "inherit",
                            zIndex: 1,
                          }}
                        >
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            color="primary"
                            onClick={() => handleEdit(cat)}
                            size="small"
                          >
                            <EditIcon transform="scale(0.6)" />
                          </IconButton>

                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            onClick={(e) => {
                              setAnchorEl(e.currentTarget);
                              setcategoryToDelete(cat.subcat_id);
                            }}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon transform="scale(0.6)" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </InfiniteScroll>

      {/* Add Modal */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          setEditId(null);
          setCategoryForms([{ name: "", category_id: "" }]);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Manage Categories</DialogTitle>
        <DialogContent dividers>
          {/* Add/Edit Form */}
          {categoryForms.map((cat, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
                mb: 2,
                alignItems: { xs: "stretch", sm: "center" },
              }}
            >
              {/* Category Autocomplete */}
              <Autocomplete
                options={categoryOptions}
                getOptionLabel={(option) => option.name || ""}
                loading={categoryLoading}
                value={
                  categoryOptions.find(
                    (opt) => String(opt.id) === String(cat.category_id),
                  ) || null
                }
                onChange={(e, value, reason) => {
                  const updated = [...categoryForms];
                  if (!updated[index])
                    updated[index] = { name: "", category_id: "" };
                  updated[index].category_id =
                    reason === "clear" ? "" : value?.id || "";
                  setCategoryForms(updated);
                  if (value?.id) {
                    const updatedErrors = [...errors];
                    if (!updatedErrors[index])
                      updatedErrors[index] = { name: "", category_id: "" };
                    updatedErrors[index].category_id = "";
                    setErrors(updatedErrors);
                  }
                }}
                onInputChange={(e, value, reason) => {
                  if (reason === "input") {
                    handleCategorySearch(value);
                  }
                }}
                ListboxProps={{
                  onScroll: (event) => {
                    const listboxNode = event.currentTarget;
                    if (
                      listboxNode.scrollTop + listboxNode.clientHeight ===
                      listboxNode.scrollHeight
                    ) {
                      if (categoryHasMore && !categoryLoading) {
                        fetchCategories(categoryPage, categorySearch);
                      }
                    }
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Category"
                    required
                    error={!!(errors[index] && errors[index].category_id)}
                    helperText={errors[index] && errors[index].category_id}
                    sx={{
                      flex: 2, // ✅ CHANGED: 2 parts (40% ratio)
                      minWidth: { xs: "100%", sm: "auto" },
                      "& .MuiInputBase-root": {
                        height: 40,
                        fontSize: "0.7rem",
                        borderRadius: "0px",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: 12,
                      },
                    }}
                  />
                )}
              />
              <TextField
                label="Sub-Category Name"
                fullWidth
                required
                value={cat.name}
                onChange={(e) => {
                  const updated = [...categoryForms];
                  updated[index].name = e.target.value;
                  setCategoryForms(updated);
                  if (e.target.value.trim()) {
                    const updatedErrors = [...errors];
                    updatedErrors[index].name = "";
                    setErrors(updatedErrors);
                  }
                }}
                error={!!(errors[index] && errors[index].name)}
                helperText={errors[index] && errors[index].name}
                sx={{
                  flex: 3, // ✅ CHANGED: 3 parts (60% ratio)
                  minWidth: { xs: "100%", sm: "auto" },
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.7rem",
                    borderRadius: "0px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 12,
                  },
                }}
              />

              {/* Delete Row button */}
              {categoryForms.length > 1 && (
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => handleRemoveField(index)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          ))}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "flex-start", // ✅ left align kar dega
            mb: editId ? 0 : -5, // ✅ yaha margin condition ke saath
          }}
        >
          <Button
            type="button"
            variant="outlined"
            startIcon={<AddIcon sx={{ fontSize: 16 }} />} // icon chhota
            onClick={handleAddRow}
            sx={{
              height: 35, // button height chhota
              fontSize: 14, // text chhota
              padding: "2px 10px", // left-right padding chhota
              minWidth: "auto", // auto width
              textTransform: "none", // uppercase remove
              border: "none",
              display: "flex",
              backgroundColor: "transparent",
              display: editId ? "none" : "flex",
              alignContent: "left",
            }}
          >
            ADD ROW
          </Button>
        </DialogActions>
        <DialogActions>
          <Button
            color="error"
            onClick={() => {
              setOpen(false);
              setEditId(null);
              setCategoryForms([{ name: "", category_id: "" }]); // ✅ form reset
              setErrors([]);
            }}
          >
            CLOSE
          </Button>
          <Button onClick={handleSave}>{editId ? "Update" : "SAVE "}</Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setcategoryToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(categoryToDelete);
                } finally {
                  setAnchorEl(null);
                  setcategoryToDelete(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setcategoryToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default DivisionManagementTable;
